export default "__VITE_ASSET__c1b777fd__"